import React, { useEffect } from "react";
import AppScreen from "./AppScreen";

const NotFound = () => {
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <AppScreen>
      <section className="w-11/12 sm:w-8/12 p-4 my-24 mx-auto bg-white rounded-lg">
        <h1 className="text-center text-xl sm:text-3xl font-semibold my-10">
          404 Not Found
        </h1>
      </section>
    </AppScreen>
  );
};

export default NotFound;
